import { Box } from "@mui/material";
import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { useState } from "react";
import { QuestionCard } from "../mobilePreview.style";

const datePickerFormats = ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY", "MM/YYYY"];
const dateTimePickerFormats = ["DD/MM/YYYY HH:mm", "MM/DD/YYYY HH:mm"];
const timePickerFormats = ["HH:mm", "HH:mm:ss"];
const luxonFormats: Record<string, string> = {
  "DD/MM/YYYY": "dd/MM/yyyy",
  "MM/DD/YYYY": "MM/dd/yyyy",
  "DD/MM/YYYY HH:mm": "dd/MM/yyyy HH:mm",
  "MM/DD/YYYY HH:mm": "MM/dd/yyyy HH:mm",
  "HH:mm": "HH:mm",
  "HH:mm:ss": "HH:mm:ss",
  YYYY: "yyyy",
  "MM/YYYY": "MM/yyyy",
};

type Props = {
  currentQuestion: any;
};

const DatePreview = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;

  const [value, setValue] = useState<DateTime | null>(null);

  return (
    <Box sx={{ ...QuestionCard, p: 2 }}>
      {dateTimePickerFormats.includes(properties.format) && (
        <DateTimePicker
          format={luxonFormats[properties?.format]}
          value={value}
          onChange={(newValue: any) => {
            setValue(newValue);
          }}
          slotProps={{
            textField: {
              sx: {
                width: "100%",
              },
              inputProps: {
                readOnly: true,
                placeholder: properties?.format,
              },
            },
          }}
          timeSteps={{
            minutes: 1,
            seconds: 1,
          }}
        />
      )}

      {timePickerFormats.includes(properties.format) && (
        <TimePicker
          views={
            properties.format === "HH:mm:ss"
              ? ["hours", "minutes", "seconds"]
              : ["hours", "minutes"]
          }
          format={luxonFormats[properties?.format]}
          value={value}
          onChange={(newValue: any) => setValue(newValue)}
          slotProps={{
            textField: {
              inputProps: {
                readOnly: true,
                placeholder: properties?.format,
              },
              sx: {
                width: "100%",
              },
            },
          }}
          timeSteps={{
            minutes: 1,
            seconds: 1,
          }}
        />
      )}

      {datePickerFormats.includes(properties.format) && (
        <DatePicker
          views={
            properties.format === "YYYY"
              ? ["year"]
              : properties.format === "MM/YYYY"
              ? ["month", "year"]
              : undefined
          }
          format={luxonFormats[properties?.format]}
          value={value}
          onChange={(newValue: any) => setValue(newValue)}
          slotProps={{
            textField: {
              sx: {
                width: "100%",
              },
              inputProps: {
                readOnly: true,
                placeholder: properties?.format,
              },
            },
          }}
        />
      )}
    </Box>
  );
};
export default DatePreview;
